var _path, _path2, _g, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfflineHandling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 144,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.912 128.949c30.435 0 55.109-24.673 55.109-55.217 0-30.543-24.783-55.217-55.109-55.217-30.435 0-55.109 24.674-55.109 55.217 0 30.544 24.674 55.217 55.109 55.217ZM135.445 109.359a4.457 4.457 0 1 0-.001-8.913 4.457 4.457 0 0 0 .001 8.913ZM141.966 91.968a3.044 3.044 0 1 0 0-6.088 3.044 3.044 0 0 0 0 6.088ZM24.738 37.427a3.043 3.043 0 1 0 0-6.087 3.043 3.043 0 0 0 0 6.087ZM6.151 96.123a5.652 5.652 0 1 0 0-11.304 5.652 5.652 0 0 0 0 11.304Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.826 93.752H71.58c-2.837 0-5.227 2.618-5.227 5.726v6.708c0 6.872 5.078 12.435 11.35 12.435 6.274 0 11.352-5.563 11.352-12.435v-6.708c0-3.272-2.39-5.726-5.228-5.726Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.74 29.475c11.983 2.772 20.909 13.504 20.909 26.33v3.433c0 28.966 21.805 47.928 21.805 47.928H27.628s21.955-18.962 21.955-47.928v-3.434c0-12.825 8.926-23.557 20.91-26.329v-1.143c0-3.434 2.688-6.122 6.123-6.122s6.123 2.688 6.123 6.122v1.143Z",
    fill: "url(#b)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.265 71.033c-3.734 0-6.87-2.389-8.065-5.823-.298-.746.15-1.493.896-1.791.747-.299 1.494.15 1.793.896.746 2.24 2.987 3.882 5.376 3.882 2.39 0 4.63-1.493 5.377-3.882.299-.747 1.045-1.195 1.792-.896.747.298 1.195 1.045.896 1.791-1.195 3.584-4.33 5.823-8.065 5.823ZM87.817 71.033c-3.733 0-6.87-2.389-8.065-5.823-.298-.746.15-1.493.897-1.791.746-.299 1.493.15 1.792.896.746 2.24 2.987 3.882 5.376 3.882 2.39 0 4.63-1.493 5.377-3.882.299-.747 1.046-1.195 1.792-.896.747.298 1.195 1.045.896 1.791-1.194 3.584-4.33 5.823-8.065 5.823ZM76.616 89.314a3.435 3.435 0 1 0 0-6.869 3.435 3.435 0 0 0 0 6.87Z",
    fill: "#ADB6C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.023 5.068V.014h19.532v5.054l-13.328 16.08h13.558v5.055H94.333v-5.055l13.329-16.08h-12.64Z",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.109 42.972v-3.216h12.638v3.216l-8.502 10.338h8.732v3.216h-13.328V53.31l8.502-10.338h-8.042Z",
    fill: "url(#d)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 76.509,
    y1: 20.245,
    x2: 76.509,
    y2: 108.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 104.561,
    y1: 0.923,
    x2: 104.561,
    y2: 15.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 117.314,
    y1: 40.339,
    x2: 117.314,
    y2: 49.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineHandling);
export default __webpack_public_path__ + "static/media/OfflineHandling.8b306fa7a38c6a8d430238eeb942440f.svg";
export { ForwardRef as ReactComponent };